module.exports = "<div class=\"container\" >\n     <router-outlet></router-outlet>\n</div>\n\n  \n  "